import {
  GET_MEMBER_TRANSACTION_ERROR,
  GET_MEMBER_TRANSACTION_START,
  GET_MEMBER_TRANSACTION_SUCCESS,
} from 'constants/action-types/groups/getMemberTransaction';
import apiAction from 'helpers/apiAction';

export default (groupId, memberId, queries) => dispatch => {
  dispatch(
    apiAction({
      url: `/groups/${groupId}/members/${memberId}/transactions`,
      queries,
      method: 'GET',
      API_REQUEST_START: GET_MEMBER_TRANSACTION_START,
      API_REQUEST_SUCCESS: GET_MEMBER_TRANSACTION_SUCCESS,
      API_REQUEST_FAILURE: GET_MEMBER_TRANSACTION_ERROR,
      onSuccess: ({ data, meta }) => {
        dispatch({
          type: GET_MEMBER_TRANSACTION_SUCCESS,
          payload: {
            data,
            meta,
          },
        });
      },
      onEnd: () => false,
    }),
  );
};
